import { API_CONSTANTS } from "../../constants/apiConstants";
import baseApi from "./baseApiService";
export const authenticationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.query({
      query: (loginCredential) => ({
        url: `${API_CONSTANTS.EVO_AUTHENTICATION_BASE_URL}${API_CONSTANTS.LOGIN}`,
        method: "POST",
        body: JSON.stringify(loginCredential),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }),
      keepUnusedDataFor: 0,
    }),

    validateBpSiteId: builder.query({
      query: (BPSiteRequest) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.VALIDATE_BP_SITE_ID}`,
        method: "POST",
        body: JSON.stringify(BPSiteRequest),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }),

      keepUnusedDataFor: 0,
    }),

    validateLoginOtp: builder.query({
      query: (otpRequest) => ({
        url: `${API_CONSTANTS.EVO_AUTHENTICATION_BASE_URL}${API_CONSTANTS.VALIDATE_LOGIN_OTP}`,
        method: "POST",
        body: JSON.stringify(otpRequest),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }),

      keepUnusedDataFor: 0,
    }),
    setPassword: builder.query({
      query: (setPasswordRequest) => ({
        url: `${API_CONSTANTS.EVO_AUTHENTICATION_BASE_URL}${API_CONSTANTS.SET_PASSWORD}`,
        method: "POST",
        body: JSON.stringify(setPasswordRequest),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }),

      keepUnusedDataFor: 0,
    }),

    UserResendCode: builder.query({
      query: () => ({
        url: `${API_CONSTANTS.EVO_AUTHENTICATION_BASE_URL}${API_CONSTANTS.USER_RESEND_CODE}`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }),
    }),

    getClinicDetails: builder.query({
      query: () => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.GET_CLINIC_DETAILS}`,
        method: "GET",
        headers: {
          "Content-Type": "*/*",
          Accept: "*/*",
        },
        credentials: "include",
      }),
    }),
    forgotPassword: builder.query({
      query: (forgotPasswordRequest) => ({
        url: `${API_CONSTANTS.EVO_AUTHENTICATION_BASE_URL}${API_CONSTANTS.FORGOT_PASSWORD_INITIALIZATION}`,
        method: "POST",
        body: JSON.stringify(forgotPasswordRequest),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }),
    }),
    validateForgotPasswordOtp: builder.query({
      query: (otpRequest) => ({
        url: `${API_CONSTANTS.EVO_AUTHENTICATION_BASE_URL}${API_CONSTANTS.VALIDATE_FORGOT_PASSWORD_OTP}`,
        method: "POST",
        body: JSON.stringify(otpRequest),
        headers: {
          "Content-Type": "application/json",
        },
        keepUnusedDataFor: 0,
        credentials: "include",
      }),
    }),
    signOut: builder.query({
      query: () => ({
        url: `${API_CONSTANTS.EVO_AUTHENTICATION_BASE_URL}${API_CONSTANTS.SIGN_OUT}`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }),
    }),
    getLoginToken: builder.query({
      query: () => ({
        url: `${API_CONSTANTS.EVO_AUTHENTICATION_BASE_URL}${API_CONSTANTS.GET_LOGIN_TOKEN}`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }),
    }),
    changePassword: builder.query({
      query: (changePasswordRequest) => ({
        url: `${API_CONSTANTS.EVO_AUTHENTICATION_BASE_URL}${API_CONSTANTS.CHANGE_PASSWORD}`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: changePasswordRequest,
        credentials: "include",
      }),
    }),
  }),
});

export const {
  useLazyLoginQuery,
  useLazyValidateBpSiteIdQuery,
  useLazySetPasswordQuery,
  useLazyValidateLoginOtpQuery,
  useLazyUserResendCodeQuery,
  useGetClinicDetailsQuery,
  useLazyForgotPasswordQuery,
  useLazyValidateForgotPasswordOtpQuery,
  useLazySignOutQuery,
  useLazyGetLoginTokenQuery,
  useLazyChangePasswordQuery,
} = authenticationApi;
